import types from "./types";

const InitialState = {
  isFetchingMasterClassByProgram: false,
  masterClassListByProgram: null,
  masterClassListByProgramError: "",

  isFetchingMasterClassCard: false,
  masterClassCard: null,
  masterClassCardError: "",

  isFetchingFullMasterClass: false,
  masterClassFullInfo: null,
  masterClassFullError: "",

  isFetchingMasterClassSystemInfo: false,
  masterClassSystemInfo: null,
  masterClassSystemInfoError: "",

  isUpdatingMasterClass: false,
  updatedMasterClass: null,
  updateMasterClassError: "",

  isCreatingMasterClass: false,
  createdMasterClass: null,
  createMasterClassError: "",

  isUpdatingLogo: false,
  updatedLogo: null,
  logoUpdateError: "",

  isUpdatingMasterClassFile: false,
  updatedMasterClassFile: null,
  fileUpdateError: "",

  isDeletingMasterClass: false,
  deletedMasterClass: null,
  masterClassDeleteError: "",

  isDeletingLogo: false,
  deletedLogo: null,
  logoDeleteError: "",

  isDeletingMasterClassFile: false,
  deletedMasterClassFile: null,
  fileDeleteError: "",

  isChangingStatus: false,
  changedStatus: null,
  statusChangeError: "",

  isFetchingGroupStudents: false,
  groupStudents: [],
  groupStudentsError: "",

  isCreatingStudent: false,
  createdStudent: null,
  studentCreationError: "",

  isAddingStudent: false,
  addedStudent: null,
  studentAdditionError: "",

  isDeletingStudent: false,
  deletedStudent: null,
  studentDeletingError: "",
};

export default (state = InitialState,
  action) => {
  switch (action.type) {
    case types.GET_MASTER_CLASS_CARD_REQUEST:
      return {
        ...state,
        isFetchingMasterClassCard: action.isFetchingMasterClassCard
      };
    case types.GET_MASTER_CLASS_CARD_COMPLETED:
      return {
        ...state,
        isFetchingMasterClassCard: action.isFetchingMasterClassCard,
        masterClassCard: action.masterClassCard
      };
    case types.GET_MASTER_CLASS_CARD_ERROR:
      return {
        ...state,
        isFetchingMasterClassCard: action.isFetchingMasterClassCard,
        masterClassCardError: action.masterClassCardError
      };

    case types.GET_MASTER_CLASS_REQUEST:
      return {
        ...state,
        isFetchingFullMasterClass: action.isFetchingFullMasterClass
      };
    case types.GET_MASTER_CLASS_COMPLETED:
      return {
        ...state,
        isFetchingFullMasterClass: action.isFetchingFullMasterClass,
        masterClassFullInfo: action.masterClassFullInfo
      };
    case types.GET_MASTER_CLASS_ERROR:
      return {
        ...state,
        isFetchingFullMasterClass: action.isFetchingFullMasterClass,
        masterClassFullInfoError: action.masterClassFullInfoError
      };

    case types.GET_MASTER_CLASS_SYSTEM_INFO_REQUEST:
      return {
        ...state,
        isFetchingMasterClassSystemInfo: action.isFetchingMasterClassSystemInfo
      };
    case types.GET_MASTER_CLASS_SYSTEM_INFO_COMPLETED:
      return {
        ...state,
        isFetchingMasterClassSystemInfo: action.isFetchingMasterClassSystemInfo,
        masterClassSystemInfo: action.masterClassSystemInfo
      };
    case types.GET_MASTER_CLASS_SYSTEM_INFO_ERROR:
      return {
        ...state,
        isFetchingMasterClassSystemInfo: action.isFetchingMasterClassSystemInfo,
        masterClassSystemInfoError: action.masterClassSystemInfoError
      };

    case types.UPDATE_MASTER_CLASS_REQUEST:
      return {
        ...state,
        isUpdatingMasterClass: action.isUpdatingMasterClass
      };
    case types.UPDATE_MASTER_CLASS_COMPLETED:
      return {
        ...state,
        isUpdatingMasterClass: action.isUpdatingMasterClass,
        updatedMasterClass: action.updatedMasterClass
      };
    case types.UPDATE_MASTER_CLASS_ERROR:
      return {
        ...state,
        isUpdatingMasterClass: action.isUpdatingMasterClass,
        updateMasterClassError: action.updateMasterClassError
      };

    case types.UPDATE_MASTER_CLASS_LOGO_REQUEST:
      return {
        ...state,
        isUpdatingLogo: action.isUpdatingLogo
      };
    case types.UPDATE_MASTER_CLASS_LOGO_COMPLETED:
      return {
        ...state,
        isUpdatingLogo: action.isUpdatingLogo,
        updatedLogo: action.updatedLogo
      };
    case types.UPDATE_MASTER_CLASS_LOGO_ERROR:
      return {
        ...state,
        isUpdatingLogo: action.isUpdatingLogo,
        logoUpdateError: action.logoUpdateError
      };

    case types.UPDATE_MASTER_CLASS_FILE_REQUEST:
      return {
        ...state,
        isUpdatingMasterClassFile: action.isUpdatingMasterClassFile
      };
    case types.UPDATE_MASTER_CLASS_FILE_COMPLETED:
      return {
        ...state,
        isUpdatingMasterClassFile: action.isUpdatingMasterClassFile,
        updatedMasterClassFile: action.updatedMasterClassFile
      };
    case types.UPDATE_MASTER_CLASS_FILE_ERROR:
      return {
        ...state,
        isUpdatingMasterClassFile: action.isUpdatingMasterClassFile,
        fileUpdateError: action.fileUpdateError
      };

    case types.DELETE_MASTER_CLASS_REQUEST:
      return {
        ...state,
        isDeletingMasterClass: action.isDeletingMasterClass
      };
    case types.DELETE_MASTER_CLASS_COMPLETED:
      return {
        ...state,
        isDeletingMasterClass: action.isDeletingMasterClass,
        deletedMasterClass: action.deletedMasterClass
      };
    case types.DELETE_MASTER_CLASS_ERROR:
      return {
        ...state,
        isDeletingMasterClass: action.isDeletingMasterClass,
        masterClassDeleteError: action.masterClassDeleteError
      };

    case types.DELETE_MASTER_CLASS_LOGO_REQUEST:
      return {
        ...state,
        isDeletingLogo: action.isDeletingLogo
      };
    case types.DELETE_MASTER_CLASS_LOGO_COMPLETED:
      return {
        ...state,
        isDeletingLogo: action.isDeletingLogo,
        deletedLogo: action.deletedLogo
      };
    case types.DELETE_MASTER_CLASS_LOGO_ERROR:
      return {
        ...state,
        isDeletingLogo: action.isDeletingLogo,
        logoDeleteError: action.logoDeleteError
      };

    case types.DELETE_MASTER_CLASS_FILE_REQUEST:
      return {
        ...state,
        isDeletingMasterClassFile: action.isDeletingMasterClassFile
      };
    case types.DELETE_MASTER_CLASS_FILE_COMPLETED:
      return {
        ...state,
        isDeletingMasterClassFile: action.isDeletingMasterClassFile,
        deletedMasterClassFile: action.deletedMasterClassFile
      };
    case types.DELETE_MASTER_CLASS_FILE_ERROR:
      return {
        ...state,
        isDeletingMasterClassFile: action.isDeletingMasterClassFile,
        fileDeleteError: action.fileDeleteError
      };

    case types.CHANGE_MASTER_CLASS_STATE_REQUEST:
      return {
        ...state,
        isChangingStatus: action.isChangingStatus
      };
    case types.CHANGE_MASTER_CLASS_STATE_COMPLETE:
      return {
        ...state,
        isChangingStatus: action.isChangingStatus,
        changedStatus: action.changedStatus
      };
    case types.CHANGE_MASTER_CLASS_STATE_ERROR:
      return {
        ...state,
        isChangingStatus: action.isChangingStatus,
        statusChangeError: action.statusChangeError
      }

    case types.DELETE_STUDENT_REQUEST:
      return {
        ...state,
        isDeletingStudent: action.isDeletingStudent
      };
    case types.DELETE_STUDENT_COMPLETED:
      return {
        ...state,
        isDeletingStudent: action.isDeletingStudent,
        deletedStudent: action.deletedStudent
      };
    case types.DELETE_STUDENT_ERROR:
      return {
        ...state,
        isDeletingStudent: action.isDeletingStudent,
        studentDeletingError: action.studentDeletingError
      };

    case types.CREATE_NEW_STUDENT_REQUEST:
      return {
        ...state,
        isCreatingStudent: action.isCreatingStudent
      };
    case types.CREATE_NEW_STUDENT_COMPLETED:
      return {
        ...state,
        isCreatingStudent: action.isCreatingStudent,
        createdStudent: action.createdStudent
      };
    case types.CREATE_NEW_STUDENT_ERROR:
      return {
        ...state,
        isCreatingStudent: action.isCreatingStudent,
        studentCreationError: action.studentCreationError
      };

    case types.ADD_EXIST_STUDENT_REQUEST:
      return {
        ...state,
        isAddingStudent: action.isAddingStudent
      };
    case types.ADD_EXIST_STUDENT_COMPLETED:
      return {
        ...state,
        isAddingStudent: action.isAddingStudent,
        addedStudent: action.addedStudent
      };
    case types.ADD_EXIST_STUDENT_ERROR:
      return {
        ...state,
        isAddingStudent: action.isAddingStudent,
        studentAdditionError: action.studentAdditionError
      };

    case types.GET_MASTER_CLASS_STUDENTS_REQUEST:
      return {
        ...state,
        isFetchingGroupStudents: action.isFetchingGroupStudents
      };
    case types.GET_MASTER_CLASS_STUDENTS_COMPLETED:
      return {
        ...state,
        isFetchingGroupStudents: action.isFetchingGroupStudents,
        groupStudents: action.groupStudents
      };
    case types.GET_MASTER_CLASS_STUDENTS_ERROR:
      return {
        ...state,
        isFetchingGroupStudents: action.isFetchingGroupStudents,
        groupStudentsError: action.groupStudentsError
      };

    case types.GET_MASTER_CLASSES_BY_PROGRAM_REQUEST:
      return {
        ...state,
        isFetchingMasterClassByProgram: action.isFetchingMasterClassByProgram
      };
    case types.GET_MASTER_CLASSES_BY_PROGRAM_COMPLETED:
      return {
        ...state,
        isFetchingMasterClassByProgram: action.isFetchingMasterClassByProgram,
        masterClassListByProgram: action.masterClassListByProgram
      };
    case types.GET_MASTER_CLASSES_BY_PROGRAM_ERROR:
      return {
        ...state,
        isFetchingMasterClassByProgram: action.isFetchingMasterClassByProgram,
        masterClassListByProgramError: action.masterClassListByProgramError
      };

    default:
      return state;
  }
};
